import { useState } from "react";
import "./DatenAA.scss";
import { transformPayload } from "../../Constants";
import { sendToAzureFunction, getFormData, deleteToken } from "../../services/ApiService";
import { handleFormSubmit } from "../../services/FormService";
import storePhoto from "../../resources/storePhoto.png";

interface DatenAAProps {
  onSubmitCallback: (status: string) => void;
  tokenID: string;
  confirmedEmail: string;
  processID: number;
}

const DatenAA: React.FC<DatenAAProps> = ({ onSubmitCallback, tokenID, confirmedEmail, processID }) => {
  const [sperrcode, setSperrcode] = useState("");
  const [sonstiges, setSonstiges] = useState("");
  const [sperrcodeError, setSperrcodeError] = useState("");
  const [sonstigesError, setSonstigesError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [hasConsent, setHasConsent] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");

  const handleCancel = async () => {
    try {
      await deleteToken(tokenID!);
      // After deletion, reload to trigger token validation and show error message
      window.location.reload();
    } catch (error) {
      // Optionally, show an error if deletion failed
      alert("Fehler beim Abbrechen des Vorgangs. Bitte versuchen Sie es erneut.");
    }
  };

  // Validate Sperrcode
  const validateSperrcode = (value: string) => {
    if (!value.trim()) {
      setSperrcodeError("Dieses Feld darf nicht leer sein.");
      return false;
    } else {
      setSperrcodeError("");
      return true;
    }
  };

  // Validate Sonstiges
  const validateSonstiges = (value: string) => {
    if (!value.trim()) {
      setSonstigesError("Dieses Feld darf nicht leer sein.");
      return false;
    } else {
      setSonstigesError("");
      return true;
    }
  };

  // Validate phone number
  const validatePhoneNumber = (value: string) => {
    const regex = /^\+?[0-9\s\-]{9,20}$/;
    if (hasConsent && !value) {
      setPhoneNumberError("Dieses Feld darf nicht leer sein.");
      return false;
    } else if (hasConsent && !regex.test(value)) {
      setPhoneNumberError("Ungültige Telefonnummer.");
      return false;
    } else {
      setPhoneNumberError("");
      return true;
    }
  };

  const validateForm = () => {
    let isValid = true;

    isValid = validateSperrcode(sperrcode) && isValid;
    isValid = validateSonstiges(sonstiges) && isValid;

    if (hasConsent) {
      isValid = validatePhoneNumber(phoneNumber) && isValid;
    }

    return isValid;
  };


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    handleFormSubmit(
      e,
      validateForm,
      getFormData,
      transformPayload,
      sendToAzureFunction,
      setIsSubmitted,
      onSubmitCallback,
      tokenID,
      confirmedEmail,
      processID
    );
  };

  return (
    <div className="email-form">

      <h2 style={{ marginTop: 0 }}>Datenübertragung von Android zu Android mit Picea Switch</h2>
      <img
        src={storePhoto}
        alt="Store Photo"
        style={{ width: "100%", height: "auto", maxWidth: "100%", borderRadius: "10px", marginBottom: "20px" }}
      />

      <p style={{width:"87%", border: "1px solid black", backgroundColor: "#f0f0f0", padding: "15px", borderRadius: "5px", textAlign: "center", marginBottom: "20px" }}>
        Bitte geben Sie Ihre Daten für die Durchführung des Services ein
      </p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Sperrcode</label>
          <input
            type="password"
            value={sperrcode}
            name="sperrcode"
            onChange={(e) => {
              setSperrcode(e.target.value);
              validateSperrcode(e.target.value);
            }}
            required
          />
          {isSubmitted && sperrcodeError && (
            <small className="error-message">{sperrcodeError}</small>
          )}
          <small>Falls der Kunde es nicht selbst entsperrt, bzw es selber nicht macht.</small>
        </div>

        <div className="form-group">
          <label>Sonstiges / Kundenwunsch</label>
          <textarea
            value={sonstiges}
            name="sonstiges"
            onChange={(e) => {
              setSonstiges(e.target.value);
              validateSonstiges(e.target.value);
            }}
            rows={3}
            required
          ></textarea>
          {isSubmitted && sonstigesError && (
            <small className="error-message">{sonstigesError}</small>
          )}
        </div>

        {/* Consent Checkbox and Phone Number */}
        <div className="form-group">
          <label className="checkbox-container">
            <input
              type="checkbox"
              checked={hasConsent}
              onChange={(e) => {
                setHasConsent(e.target.checked);
                if (!e.target.checked) {
                  setPhoneNumber("");
                  setPhoneNumberError("");
                }
              }}
            />
            <span className="checkmark"></span>
            Ich stimme zu, dass ich für Angelegenheiten im Zusammenhang mit dieser Anfrage kontaktiert werden darf.
          </label>
        </div>

        {hasConsent && (
          <div className="form-group">
            <label>Telefonnummer</label>
            <input
              type="tel"
              value={phoneNumber}
              name="HandyNummer"
              onChange={(e) => {
                setPhoneNumber(e.target.value);
                validatePhoneNumber(e.target.value);
              }}
              required={hasConsent}
            />
            <small>Bitte geben Sie eine gültige Telefonnummer ein.</small>
            {isSubmitted && phoneNumberError && (
              <small className="error-message">{phoneNumberError}</small>
            )}
          </div>
        )}
        <button type="submit">Absenden</button>
        <button type="button" onClick={handleCancel} style={{ backgroundColor: "red", marginBottom: 0 }}>
          Abbrechen
        </button>
        <small style={{color: "#777"}}>Durch das Abbrechen wird der Vorgang gestoppt und Ihre Daten werden nicht weiter verwendet</small>
      </form>
    </div>
  );
};

export default DatenAA;